import React from "react";

export const STATUS_LABELS = {
  draft: "Draft/Quotation",
  new_order: "New Order",
  design_pending: "Order Confirmed",
  ready_to_cut: "Design Approved",
  in_cutting: "In CNC Machine",
  // Gate & Railing workflow
  framing_making: "Framing Making",
  design_making: "Design Making",
  design_cutting: "Design Cutting",
  sheet_size_pending: "Upload Sheet Size",
  ready_for_installation: "Ready for Installation",
  on_hold: "On Hold",
  // Common closing states
  completed: "Ready for Delivery",
  delivered: "Dispatched & Settled",
};

const STATUS_COLORS = {
  draft: { fg: "#94A3B8", bg: "rgba(148,163,184,0.12)" },
  new_order: { fg: "#F59E0B", bg: "rgba(245,158,11,0.12)" },
  design_pending: { fg: "#F59E0B", bg: "rgba(245,158,11,0.15)" },
  ready_to_cut: { fg: "#F59E0B", bg: "rgba(245,158,11,0.20)" },
  in_cutting: { fg: "#3B82F6", bg: "rgba(59,130,246,0.20)" },
  framing_making: { fg: "#A78BFA", bg: "rgba(167,139,250,0.15)" },
  design_making: { fg: "#F59E0B", bg: "rgba(245,158,11,0.15)" },
  design_cutting: { fg: "#3B82F6", bg: "rgba(59,130,246,0.20)" },
  sheet_size_pending: { fg: "#22D3EE", bg: "rgba(34,211,238,0.15)" },
  ready_for_installation: { fg: "#A78BFA", bg: "rgba(167,139,250,0.20)" },
  on_hold: { fg: "#F97316", bg: "rgba(249,115,22,0.18)" },
  completed: { fg: "#10B981", bg: "rgba(16,185,129,0.14)" },
  delivered: { fg: "#10B981", bg: "rgba(16,185,129,0.28)" },
};

export default function StatusBadge({ status, size = "sm" }) {
  const c = STATUS_COLORS[status] || STATUS_COLORS.draft;
  const label = STATUS_LABELS[status] || status;
  const showPulse = status === "in_cutting" || status === "ready_to_cut" || status === "design_cutting";
  return (
    <span
      className="status-pill"
      style={{
        color: c.fg,
        background: c.bg,
        borderColor: c.fg,
        fontSize: size === "lg" ? 14 : 11,
        padding: size === "lg" ? "6px 14px" : "3px 10px",
      }}
      data-testid={`status-badge-${status}`}
    >
      {showPulse && <span className="pulse-dot" />}
      {label}
    </span>
  );
}
